import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { brandingService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useApplyBrandingSettingsAgentMutation = (agentId: string) => {
	const dispatch = useDispatch();

	return useMutation(
		() =>
			brandingService.applyBrandingSettingsAgent({
				agentId,
			}),
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useApplyBrandingSettingsAgentMutation;
